<h1 class="skymiles-landing-page-earns__header">{{ content.title }}</h1>
<div
  [skeletonMetaData]="{
    loaded: content.banner.loaded,
    error: content.banner.error,
    disabled: content.banner.disabled
  }"
  class="skymiles-landing-page-earns__container--gap"
  (action)="redirect($event)"
  auraSkeletonLoader
>
  <idp-fast-action-banner-page
    *ngIf="!content.banner.disabled"
    (offerAction)="redirect(content.banner.offer.action?.link?.url || '')"
    [config]="content.banner.offerConfig"
    [content]="content.banner.offer"
    [displaySecondaryHeader]="displaySecondaryHeader"
    [styles]="content.banner.offerStyles"
    [title]="content.title"
  ></idp-fast-action-banner-page>
</div>
<idp-offers
  [content]="content.offers"
  [skeletonMetaData]="{
    loaded: content.offers.loaded,
    error: content.offers.error,
    disabled: content.offers.disabled
  }"
  class="skymiles-landing-page-earns__container--gap"
  (action)="redirect($event)"
  auraSkeletonLoader
></idp-offers>
<idp-partners
  *ngIf="content.partners"
  [showLinked]="true"
  class="skymiles-landing-page-earns__container--gap"
></idp-partners>
<idp-related-links
  *ngIf="!content.relatedLinks.disabled"
  [content]="content.relatedLinks"
  class="skymiles-landing-page-earns__container--gap"
></idp-related-links>
